<template>
  <div>
    <b-container fluid>
        <b-row>
            <b-col style="text-align:center;">
                <QRCode :URL="salseQRCode" :QRCodeWidth="250"></QRCode>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                邀請你的親朋好友用手機拍攝QR Code，EGL名單輕鬆入手！
            </b-col>
        </b-row>        
    </b-container>
  </div>
</template>

<script>
import QRCode from "../Main/QRCode.vue";
  export default {
    props: ["salseQRCode"],
    data() {
      return {
      };
    },
    components: {
      QRCode,
    },
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Mobile/SalseQRCodePage.vue